<template>
  <BaseCard :title="'ArtHuddle'" :highlightLastWord="false">
    <div class="flex flex-col justify-center gap-4">
      <div class="w-full grid lg:grid-cols-2 lg:gap-20">
        <h5 class="lg:justify-self-end lg:pr-6 font-medium">Backend Engineer</h5>
        <h5 class="lg:justify-self-start lg:pl-6 font-medium">January 2026 - May 2026</h5>
      </div>

      <p class="text-center items-center px-4 gap-2">
        <span class="block">
          Launched a multi-user C++ drawing app with custom GUI rendering, text input, audio playback, real-time canvas updates in a team of 3
        </span>
        <span class="block">
          Engineered a thread-safe client-server network with sockets to synchronize drawing, dragging, updating, & deleting elements between connected users
        </span>
        <span class="block">
          Architected an SDL3 graphics API utilizing CRTP, threading, factories, custom event system singleton, & metaprogramming for reusable drawing elements & efficient SDL screen drawing
        </span>
        <span class="block">
          Presented to PhD students & professor as stakeholders biweekly, iterating on feedback to improve usability & functionality
        </span>
        <span class="block">
          View our
          <a href="https://github.com/cgreen2048/ArtHuddle" target="_blank" class="link-in-text">GitHub repo</a>
          or 
          <a href="https://www.youtube.com/watch?v=QVpjFrVt47o" target="_blank" class="link-in-text">watch a demo</a>!
        </span>
      
    </p>
    <span class="flex flex-col place-items-center overflow-hidden">
        <img class="w-[50%] h-auto rounded-lg cursor-pointer"  :src="artHuddleDemo" @click="openImageMenu(artHuddleDemo, 'ArtHuddle Demo', $event.currentTarget)">
    </span>
    </div>
  </BaseCard>
</template>

<script lang="ts" setup>
import BaseCard from '@/features/global/BaseCard.vue';
import artHuddleDemo from '@/assets/Projects/ArtHuddlePhotos/ArtHuddleDemo.gif';
import { useImageViewer } from '@/features/composables/useImageViewer';

const { openImageMenu } = useImageViewer();
</script>